module.exports = {
  "props": [
    {
      "name": "alt",
      "type": "string",
      "default": "undefined",
      "source": "v-parallax",
      "description": {
        "en": "Attaches an alt property to the parallax image",
        "ja": "パララックス画像にalt属性を設定します。",
        "zh-Hans": "将 alt 属性附加到视差图像上"
      }
    },
    {
      "name": "height",
      "type": [
        "string",
        "number"
      ],
      "default": 500,
      "source": "translatable",
      "description": {
        "en": "Sets the height for the component",
        "ja": "コンポーネントの高さを設定します",
        "zh-Hans": "设置组件高度"
      }
    },
    {
      "name": "src",
      "type": "string",
      "default": "undefined",
      "source": "v-parallax",
      "description": {
        "en": "The image to parallax",
        "ja": "parallaxの画像",
        "zh-Hans": "受视差影响的图像"
      }
    },
    {
      "name": "srcset",
      "type": "string",
      "default": "undefined",
      "source": "v-parallax",
      "description": {
        "en": "A set of alternate images to use based on device size. [Read more...](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-srcset)",
        "ja": "デバイスのサイズに基づいて使用する代替画像のセット。 [続きを読む...](https://developer.mozilla.org/ja/docs/Web/HTML/Element/img#attr-srcset)",
        "zh-Hans": "根据设备大小使用的一组备用图像。[Read more...](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-srcset)"
      }
    }
  ],
  "mixins": [
    "translatable"
  ],
  "slots": [
    {
      "name": "default",
      "description": {
        "en": "The default Vue slot.",
        "ja": "デフォルトの Vue slot",
        "zh-Hans": "默认Vue 插槽。"
      }
    }
  ],
  "events": [],
  "functions": [],
  "name": "v-parallax",
  "sass": [
    {
      "name": "$parallax-transition",
      "default": ".3s opacity map-get($transition, 'swing') !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$parallax-padding",
      "default": "0 1rem !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    }
  ],
  "component": true
}